import React, { useId } from "react";

interface SuccessCheckProps {
  className?: string;
}

const SuccessCheck: React.FC<SuccessCheckProps> = ({ className }) => {
  const titleId = useId();

  return (
    <svg width="50" height="50" viewBox="0 0 50 50" aria-labelledby={titleId} className={className}>
      <title id={titleId}>Success tick icon</title>
      <path
        d="M25 50C11.1914 50 0 38.8086 0 25C0 11.1914 11.1914 0 25 0C38.8086 0 50 11.1914 50 25C50 38.8086 38.8086 50 25 50ZM25 4.6875C13.7793 4.6875 4.6875 13.7793 4.6875 25C4.6875 36.2207 13.7793 45.3125 25 45.3125C36.2207 45.3125 45.3125 36.2207 45.3125 25C45.3125 13.7793 36.2207 4.6875 25 4.6875ZM31.9043 16.5918C32.666 15.5469 34.1309 15.3125 35.1758 16.0742C36.2207 16.8359 36.4551 18.3008 35.6934 19.3457L23.7695 35.752C23.3691 36.3086 22.7441 36.6602 22.0605 36.709C21.377 36.7578 20.7031 36.5137 20.2246 36.0352L14.7656 30.5762C13.8477 29.6582 13.8477 28.1738 14.7656 27.2656C15.6836 26.3574 17.168 26.3477 18.0762 27.2656L21.5918 30.7813L31.9043 16.6016V16.5918Z"
        fill="#38BFA8"
      />
    </svg>
  );
};

export default SuccessCheck;
